<template>
    <div>
        <entity-overview entity-type="Job"></entity-overview>
    </div>
</template>
<style scoped>
</style>
<script>
    function initialState() {
        return {
            loading: false
        };
    }
    export default {
        name: "JobsView",
        data: function () {
            return initialState();
        },
        components : {
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
            reset: function () {
                Object.assign(this.$data, initialState());
            },
        },
        computed: {
        }
    };
</script>